module.exports = __webpack_public_path__ + "media/images/user/7-38b4749e5e5396fcaa3a270214415530.jpg";